"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilesFromDataTransferItems = void 0;
var didShowInfo = false;
function getFilesFromDataTransferItems(dataTransferItems, options) {
    if (options === void 0) { options = { raw: false }; }
    return __awaiter(this, void 0, void 0, function () {
        var checkErr, readFile, dirReadEntries, readDir, getFilesFromEntry, files, entries, i, ii, newEntry, _i, entries_1, entry, newFiles;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    checkErr = function (err) {
                        if (didShowInfo)
                            return;
                        if (err.name !== 'EncodingError')
                            return;
                        didShowInfo = true;
                        var infoMsg = "".concat(err.name, " occured within datatransfer-files-promise module\n")
                            + "Error message: \"".concat(err.message, "\"\n")
                            + 'Try serving html over http if currently you are running it from the filesystem.';
                        console.warn(infoMsg);
                    };
                    readFile = function (entry, path) {
                        if (path === void 0) { path = ''; }
                        return new Promise(function (resolve, reject) {
                            entry.file(function (file) {
                                if (!options.raw)
                                    file.filepath = path + file.name; // save full path
                                resolve(file);
                            }, function (err) {
                                checkErr(err);
                                reject(err);
                            });
                        });
                    };
                    dirReadEntries = function (dirReader, path) {
                        return new Promise(function (resolve, reject) {
                            dirReader.readEntries(function (entries) { return __awaiter(_this, void 0, void 0, function () {
                                var files, _i, entries_2, entry, itemFiles;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            files = [];
                                            _i = 0, entries_2 = entries;
                                            _a.label = 1;
                                        case 1:
                                            if (!(_i < entries_2.length)) return [3 /*break*/, 4];
                                            entry = entries_2[_i];
                                            return [4 /*yield*/, getFilesFromEntry(entry, path)];
                                        case 2:
                                            itemFiles = _a.sent();
                                            files = files.concat(itemFiles);
                                            _a.label = 3;
                                        case 3:
                                            _i++;
                                            return [3 /*break*/, 1];
                                        case 4:
                                            resolve(files);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, function (err) {
                                checkErr(err);
                                reject(err);
                            });
                        });
                    };
                    readDir = function (entry, path) { return __awaiter(_this, void 0, void 0, function () {
                        var dirReader, newPath, files, newFiles;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    dirReader = entry.createReader();
                                    newPath = path + entry.name + '/';
                                    files = [];
                                    _a.label = 1;
                                case 1: return [4 /*yield*/, dirReadEntries(dirReader, newPath)];
                                case 2:
                                    newFiles = _a.sent();
                                    files = files.concat(newFiles);
                                    _a.label = 3;
                                case 3:
                                    if (newFiles.length > 0) return [3 /*break*/, 1];
                                    _a.label = 4;
                                case 4: return [2 /*return*/, files];
                            }
                        });
                    }); };
                    getFilesFromEntry = function (entry, path) {
                        if (path === void 0) { path = ''; }
                        return __awaiter(_this, void 0, void 0, function () {
                            var file, files_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!entry.isFile) return [3 /*break*/, 2];
                                        return [4 /*yield*/, readFile(entry, path)];
                                    case 1:
                                        file = _a.sent();
                                        return [2 /*return*/, [file]];
                                    case 2:
                                        if (!entry.isDirectory) return [3 /*break*/, 4];
                                        return [4 /*yield*/, readDir(entry, path)];
                                    case 3:
                                        files_1 = _a.sent();
                                        return [2 /*return*/, files_1];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        });
                    };
                    files = [];
                    entries = [];
                    // Pull out all entries before reading them
                    for (i = 0, ii = dataTransferItems.length; i < ii; i++) {
                        newEntry = dataTransferItems[i].webkitGetAsEntry();
                        entries.push(newEntry);
                    }
                    _i = 0, entries_1 = entries;
                    _a.label = 1;
                case 1:
                    if (!(_i < entries_1.length)) return [3 /*break*/, 4];
                    entry = entries_1[_i];
                    return [4 /*yield*/, getFilesFromEntry(entry)];
                case 2:
                    newFiles = _a.sent();
                    files = files.concat(newFiles);
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, files];
            }
        });
    });
}
exports.getFilesFromDataTransferItems = getFilesFromDataTransferItems;
